import { useContext } from 'react';
import MoreMenuContext from './planingMoreMenuContext';


const useMoreMenu = () => useContext(MoreMenuContext); 

export default useMoreMenu;